export default (params) => ({
    datasource: params.datasource,
    emptyOptionsMessage: params.emptyOptionsMessage ?? 'No results match your search.',
    focusedOptionIndex: null,
    open: false,
    options: {},
    empty: params.empty ?? 'Select an option',
    wireModel: params.wireModel,
    search: '',
    selected: params.selected,
    limit: null,
    length: 0,
    searching: false,
    fillPaginate: params.fillPaginate,
    fillSource: params.fillSource,
    skip: 0,
    modalState: params.modalState,
    init() {
        const self = this

        this.$watch('modalState', (async value => {
            const wireModel = self.$wire.get(self.wireModel)

            self.limit = self.$wire.get('loadMoreLimit.' + self.wireModel);
            self.length = Object.keys(self.options).length

            self.options = await self.loadData()

            if (!(self.value in self.options.map((value) => value['id']))) self.value = null

            if (wireModel) {
                self.$wire.call('getSourceById', wireModel).then(value => {
                    return self.selected = JSON.parse(value).label
                })
            }

            self.selected = self.empty
        }))

        this.$watch('open', (value => {
            if (value) {
                self.limit = self.$wire.get('loadMoreLimit.' + self.wireModel);
                self.length = Object.keys(self.options).length
                self.skip = self.$wire.get('loadMoreSkip.' +self.wireModel)
                self.hasMoreData()
                self.hasPrevious()
            }
        }))
    },
    async loadData () {
        await this.$wire.call(this.fillSource)

        return await this.$wire.get(this.datasource)
    },
    loadLimit: function () {
        this.limit = this.$wire.get('loadMoreLimit.' + this.wireModel);
    },
    close: function () {
        this.open = false
        this.focusedOptionIndex = null
        this.search = ''
    },
    selectOption: function () {
        if (!this.open) return this.toggleVisibility()

        if (this.focusedOptionIndex === -1) {
            this.selected = this.placeholder

            this.$wire.set(this.wireModel, '')

            this.close()
            return;
        }

        if (this.searching) {
            this.value = Object.values(this.options)[this.focusedOptionIndex]['id']
            this.selected = Object.values(this.options)[this.focusedOptionIndex]['label']
        } else {
            this.value = this.options[this.focusedOptionIndex]['id']
            this.selected = this.options[this.focusedOptionIndex]['label']
        }

        this.$wire.set(this.wireModel, this.value)
        this.search = null
        this.refresh()
        this.close()
    },
    toggleVisibility: function () {
        if (this.open) return this.close()

        if (this.focusedOptionIndex < 0) this.focusedOptionIndex = 0

        this.open = true

        this.$nextTick(() => setTimeout(() => this.$refs.search.focus(), 100))
    },
    previous: function () {
        const self = this;

        this.$wire.selectPaginatePrevious(self.wireModel)
        this.$wire.call(this.fillSource)
        setTimeout(function () {
            self.options = self.$wire.get(self.datasource);
            self.length  = Object.keys(self.options).length;
        }, 400)
    },
    next: function () {
        const self = this;

        this.$wire.selectPaginateNext(self.wireModel, self.limit)
        this.$wire.call(this.fillSource)
        setTimeout(function () {
            self.options = self.$wire.get(self.datasource);
            self.length  = Object.keys(self.options).length;

            self.$refs.search.focus();
        }, 400)
    },
    hasPrevious: function () {
        return this.$wire.get('loadMoreSkip.' + this.wireModel) > 0
    },
    hasMoreData: function () {
        return this.limit <= this.length
    },
    refresh: async function () {
        const self = this;

        this.$wire.set('loadMoreSkip.' + self.wireModel, 0)
        this.$wire.set('loadMoreSearch.' + self.wireModel, self.search)
        await this.$wire.call(this.fillSource)

        self.options = self.$wire.get(self.datasource);
        self.length  = Object.keys(self.options).length;
    },
    getId: function (index) {
        if (Object.values(this.options)[index] !== undefined)

            return Object.values(this.options)[index]['id'];
    },
    getPrimaryText: function (index) {
        if (Object.values(this.options)[index] !== undefined)

            return Object.values(this.options)[index]['label']
    },
    getSecondText: function (index) {
        if (Object.values(this.options)[index] !== undefined)

            return Object.values(this.options)[index]['info']
    },
})
